import React, { useState, useEffect } from 'react';
import { db, auth } from './firebase';
import { collection, addDoc, serverTimestamp, doc, updateDoc, increment, onSnapshot, query, where, orderBy } from 'firebase/firestore';

const Shop = ({ onBack }) => {
    const [activeTab, setActiveTab] = useState('PREMIUM'); 
    const [subFilter, setSubFilter] = useState('ALL');
    const [loading, setLoading] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('points');
    const [cashType, setCashType] = useState('Kpay'); 
    
    const [currentUserData, setCurrentUserData] = useState(null);
    const [adminSettings, setAdminSettings] = useState({ kpayNumber: '09756986331', kpayName: 'Aung Hein Htet' });
    const [myOrders, setMyOrders] = useState([]);
    const [shopItems, setShopItems] = useState([]);

    const [showConfirm, setShowConfirm] = useState(null);
    const [playerID, setPlayerID] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [accName, setAccName] = useState('');
    const [accNumber, setAccNumber] = useState('');
    const [transactionId, setTransactionId] = useState('');

    useEffect(() => {
        if (!auth.currentUser) return;
        
        const unsubUser = onSnapshot(doc(db, "users", auth.currentUser.uid), (doc) => {
            if (doc.exists()) setCurrentUserData(doc.data());
        });

        const qOrders = query(collection(db, "shop_orders"), where("userId", "==", auth.currentUser.uid), orderBy("createdAt", "desc"));
        const unsubOrders = onSnapshot(qOrders, (s) => {
            setMyOrders(s.docs.map(d => ({ id: d.id, ...d.data() })));
        });

        const unsubItems = onSnapshot(collection(db, "shop_items"), (s) => {
            setShopItems(s.docs.map(d => ({ id: d.id, ...d.data() })));
        });

        return () => { unsubUser(); unsubOrders(); unsubItems(); };
    }, []);

    // ပြင်ဆင်ထားသော Filter Logic
    const filteredItems = shopItems.filter(item => {
        if (activeTab === 'PREMIUM') return item.mainCat === 'PREMIUM';
        if (activeTab === 'GAMES') {
            if (subFilter === 'ALL') return item.mainCat === 'GAMES';
            return item.mainCat === 'GAMES' && item.subCat === subFilter;
        }
        if (activeTab === 'TOPUP') {
            if (subFilter === 'ALL') return item.mainCat === 'TOPUP';
            return item.mainCat === 'TOPUP' && item.subCat === subFilter;
        }
        return false;
    });

    const handlePurchase = async () => {
        const currentPrice = paymentMethod === 'points' ? Number(showConfirm.pricePts) : Number(showConfirm.priceMmk);

        if (paymentMethod === 'cash' && (!accName || !accNumber || !transactionId)) return alert("ငွေလွှဲအချက်အလက် ပြည့်စုံအောင်ဖြည့်ပါ");
        if (showConfirm.mainCat === 'GAMES' && !playerID) return alert("Game ID နှင့် Server ID ထည့်ပေးပါ");
        if (showConfirm.mainCat === 'TOPUP' && !phoneNumber) return alert("ဖုန်းနံပါတ် ထည့်ပေးပါ");

        if (paymentMethod === 'points' && (currentUserData?.points || 0) < currentPrice) {
            return alert("Points မလုံလောက်ပါ");
        }

        setLoading(true);
        try {
            const orderData = {
                userId: auth.currentUser.uid,
                userName: currentUserData?.displayName || 'Unknown User',
                userEmail: auth.currentUser.email,
                productName: `${showConfirm.subCat} - ${showConfirm.name}`,
                mainCat: showConfirm.mainCat,
                subCat: showConfirm.subCat,
                price: currentPrice,
                paymentMethod,
                cashType: paymentMethod === 'cash' ? cashType : 'Points',
                status: 'pending',
                createdAt: serverTimestamp(),
                details: {
                    playerID: playerID || null,
                    phoneNumber: phoneNumber || null,
                    accName: accName || null,
                    accNumber: accNumber || null,
                    transactionId: transactionId || null
                }
            };

            await addDoc(collection(db, "shop_orders"), orderData);

            if (paymentMethod === 'points') {
                await updateDoc(doc(db, "users", auth.currentUser.uid), {
                    points: increment(-currentPrice)
                });
            }

            alert("Order တင်ပြီးပါပြီ။ Admin က စစ်ဆေးပြီးနောက် ချက်ချင်းလုပ်ဆောင်ပေးပါမည်။");
            setShowConfirm(null);
            resetForm();
        } catch (err) {
            alert("Error: " + err.message);
        }
        setLoading(false);
    };

    const resetForm = () => {
        setPlayerID(''); setPhoneNumber(''); setAccName(''); setAccNumber(''); setTransactionId('');
    };

    return (
        <div style={styles.container}>
            {/* Header */}
            <div style={styles.header}>
                <button onClick={onBack} style={styles.iconBtn}>
                    <span className="material-icons-round">arrow_back_ios</span>
                </button>
                <div style={{ textAlign: 'center' }}>
                    <h3 style={{ margin: 0, color: '#D4AF37', fontSize: '16px' }}>BABYLON SHOP</h3>
                    {currentUserData?.premium > 0 && (
                        <div style={{ fontSize: '10px', color: '#2ecc71' }}>Premium: {currentUserData.premium} Days Remaining</div>
                    )}
                </div>
                <div style={styles.pointsBadge}>
                    <span className="material-icons-round" style={{ fontSize: '14px' }}>monetization_on</span>
                    {currentUserData?.points?.toLocaleString() || 0}
                </div>
            </div>

            {/* Main Tabs */}
            <div style={styles.tabs}>
                {['PREMIUM', 'GAMES', 'TOPUP', 'HISTORY'].map(tab => (
                    <button 
                        key={tab}
                        onClick={() => { setActiveTab(tab); setSubFilter('ALL'); }} 
                        style={activeTab === tab ? styles.activeTab : styles.tab}
                    >
                        {tab}
                    </button>
                ))}
            </div>

            {/* Sub Filters - Corrected Logic */}
            {activeTab === 'GAMES' && (
                <div style={styles.subFilters}>
                    <button onClick={() => setSubFilter('ALL')} style={subFilter === 'ALL' ? styles.activeSub : styles.sub}>ALL</button>
                    <button onClick={() => setSubFilter('MLBB')} style={subFilter === 'MLBB' ? styles.activeSub : styles.sub}>MLBB</button>
                    <button onClick={() => setSubFilter('PUBG')} style={subFilter === 'PUBG' ? styles.activeSub : styles.sub}>PUBG</button>
                </div>
            )}
            {activeTab === 'TOPUP' && (
                <div style={styles.subFilters}>
                    <button onClick={() => setSubFilter('ALL')} style={subFilter === 'ALL' ? styles.activeSub : styles.sub}>ALL</button>
                    {['MPT', 'ATOM', 'OOREDOO', 'MYTEL'].map(op => (
                        <button key={op} onClick={() => setSubFilter(op)} style={subFilter === op ? styles.activeSub : styles.sub}>{op}</button>
                    ))}
                </div>
            )}

            <div style={styles.content}>
                {activeTab === 'HISTORY' ? (
                    <div style={styles.historyList}>
                        {myOrders.length === 0 ? <p style={{ textAlign: 'center', color: '#8b949e' }}>No orders found.</p> :
                            myOrders.map(order => (
                                <div key={order.id} style={styles.historyCard}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <b style={{ color: '#fff', fontSize: '13px' }}>{order.productName}</b>
                                        <span style={{ 
                                            color: order.status === 'completed' ? '#2ecc71' : (order.status === 'rejected' ? '#ff4444' : '#f1c40f'),
                                            fontWeight: 'bold', fontSize: '11px'
                                        }}>
                                            {order.status?.toUpperCase()}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px', fontSize: '11px' }}>
                                        <span style={{ color: '#8b949e' }}>{new Date(order.createdAt?.toDate()).toLocaleString()}</span>
                                        <span style={{ color: '#D4AF37' }}>{order.price?.toLocaleString()} {order.paymentMethod === 'points' ? 'Pts' : 'MMK'}</span>
                                    </div>
                                    {order.status === 'rejected' && order.reason && (
                                        <div style={styles.rejectReasonBox}>Reason: {order.reason}</div>
                                    )}
                                </div>
                            ))
                        }
                    </div>
                ) : (
                    <div style={styles.grid}>
                        {filteredItems.map((item) => (
                            <div key={item.id} style={styles.itemCard} onClick={() => setShowConfirm(item)}>
                                <div style={styles.subCatLabel}>{item.subCat}</div>
                                <div style={{ fontWeight: '600', color: '#fff', fontSize: '14px', marginBottom: '8px' }}>{item.name}</div>
                                <div style={styles.priceContainer}>
                                    <div style={{ color: '#D4AF37' }}>{item.pricePts?.toLocaleString()} Pts</div>
                                    <div style={{ color: '#8b949e', fontSize: '11px' }}>{item.priceMmk?.toLocaleString()} MMK</div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Purchase Modal */}
            {showConfirm && (
                <div style={styles.overlay}>
                    <div style={styles.modal}>
                        <h4 style={{ margin: '0 0 15px 0', color: '#D4AF37', textAlign: 'center' }}>CONFIRM ORDER</h4>
                        <div style={styles.confirmInfo}>
                            <div style={{ fontSize: '11px', color: '#8b949e' }}>{showConfirm.subCat}</div>
                            <div style={{ color: '#fff', fontWeight: 'bold', fontSize: '16px' }}>{showConfirm.name}</div>
                            <div style={{ marginTop: '10px', color: '#D4AF37', fontWeight: 'bold' }}>
                                Price: {paymentMethod === 'points' ? `${showConfirm.pricePts?.toLocaleString()} Pts` : `${showConfirm.priceMmk?.toLocaleString()} MMK`}
                            </div>
                        </div>

                        <div style={styles.paymentSwitch}>
                            <button onClick={() => setPaymentMethod('points')} style={paymentMethod === 'points' ? styles.activeSwitch : styles.switchBtn}>POINTS</button>
                            <button onClick={() => setPaymentMethod('cash')} style={paymentMethod === 'cash' ? styles.activeSwitch : styles.switchBtn}>CASH</button>
                        </div>

                        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                            {showConfirm.mainCat === 'GAMES' && <input placeholder="Game ID + Server ID" value={playerID} onChange={e => setPlayerID(e.target.value)} style={styles.input} />}
                            {showConfirm.mainCat === 'TOPUP' && <input placeholder="Phone Number (09...)" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} style={styles.input} />}
                            
                            {paymentMethod === 'cash' && (
                                <div style={styles.cashForm}>
                                    <div style={styles.adminPayBox}>
                                        Pay to: {adminSettings.kpayNumber} ({adminSettings.kpayName})
                                    </div>
                                    <select value={cashType} onChange={e => setCashType(e.target.value)} style={styles.input}>
                                        <option value="Kpay">Kpay</option>
                                        <option value="Wave">Wave</option>
                                    </select>
                                    <input placeholder="လွှဲသူအမည်" value={accName} onChange={e => setAccName(e.target.value)} style={styles.input} />
                                    <input placeholder="လွှဲသူဖုန်းနံပါတ်" value={accNumber} onChange={e => setAccNumber(e.target.value)} style={styles.input} />
                                    <input placeholder="TXN ID (နောက်ဆုံး ၆ လုံး)" value={transactionId} onChange={e => setTransactionId(e.target.value)} style={styles.input} />
                                </div>
                            )}
                        </div>

                        <button onClick={handlePurchase} disabled={loading} style={styles.confirmBtn}>
                            {loading ? "Processing..." : "CONFIRM NOW"}
                        </button>
                        <button onClick={() => { setShowConfirm(null); resetForm(); }} style={styles.cancelBtn}>CANCEL</button>
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = {
    container: { minHeight: '100vh', background: '#0a0c10', color: '#c9d1d9', fontFamily: 'Inter, sans-serif' },
    header: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '15px', background: '#11141b', position: 'sticky', top: 0, zIndex: 10, borderBottom: '1px solid #21262d' },
    iconBtn: { background: 'none', border: 'none', color: '#fff', cursor: 'pointer' },
    pointsBadge: { background: 'rgba(212,175,55,0.1)', color: '#D4AF37', padding: '5px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: '5px', border: '1px solid rgba(212,175,55,0.2)' },
    tabs: { display: 'flex', background: '#11141b', padding: '0 5px' },
    tab: { flex: 1, padding: '12px 5px', background: 'none', border: 'none', color: '#8b949e', fontSize: '11px', fontWeight: 'bold' },
    activeTab: { flex: 1, padding: '12px 5px', background: 'none', borderBottom: '3px solid #D4AF37', color: '#D4AF37', fontSize: '11px', fontWeight: 'bold' },
    subFilters: { display: 'flex', padding: '12px', gap: '10px', overflowX: 'auto', background: '#0a0c10' },
    sub: { padding: '6px 16px', borderRadius: '20px', background: '#161b22', border: '1px solid #30363d', color: '#8b949e', fontSize: '11px', whiteSpace: 'nowrap' },
    activeSub: { padding: '6px 16px', borderRadius: '20px', background: '#D4AF37', border: '1px solid #D4AF37', color: '#000', fontSize: '11px', whiteSpace: 'nowrap', fontWeight: 'bold' },
    content: { padding: '15px' },
    grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' },
    itemCard: { background: '#161b22', padding: '15px', borderRadius: '16px', border: '1px solid #21262d', position: 'relative', overflow: 'hidden' },
    subCatLabel: { fontSize: '9px', color: '#D4AF37', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '4px', letterSpacing: '1px' },
    priceContainer: { marginTop: '10px', borderTop: '1px solid #21262d', paddingTop: '8px', fontWeight: 'bold', fontSize: '13px' },
    historyList: { display: 'flex', flexDirection: 'column', gap: '10px' },
    historyCard: { background: '#161b22', padding: '15px', borderRadius: '12px', border: '1px solid #21262d' },
    rejectReasonBox: { marginTop: '8px', padding: '8px', background: 'rgba(255, 68, 68, 0.1)', borderRadius: '6px', fontSize: '11px', color: '#ffbaba', borderLeft: '3px solid #ff4444' },
    overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000, padding: '20px' },
    modal: { background: '#161b22', padding: '20px', borderRadius: '24px', width: '100%', maxWidth: '360px', border: '1px solid #30363d' },
    confirmInfo: { background: '#0a0c10', padding: '15px', borderRadius: '15px', marginBottom: '15px', textAlign: 'center' },
    paymentSwitch: { display: 'flex', background: '#0a0c10', borderRadius: '12px', padding: '4px', marginBottom: '15px' },
    switchBtn: { flex: 1, padding: '10px', background: 'transparent', border: 'none', color: '#8b949e', fontSize: '12px', fontWeight: 'bold' },
    activeSwitch: { flex: 1, padding: '10px', background: '#D4AF37', color: '#000', borderRadius: '10px', fontWeight: 'bold', fontSize: '12px' },
    input: { width: '100%', padding: '12px', marginTop: '10px', background: '#0a0c10', border: '1px solid #30363d', borderRadius: '10px', color: '#fff', boxSizing: 'border-box', fontSize: '14px' },
    cashForm: { marginTop: '10px', borderTop: '1px solid #30363d', paddingTop: '10px' },
    adminPayBox: { fontSize: '12px', color: '#D4AF37', background: 'rgba(212,175,55,0.1)', padding: '10px', borderRadius: '8px', textAlign: 'center' },
    confirmBtn: { width: '100%', padding: '14px', marginTop: '20px', background: '#D4AF37', border: 'none', borderRadius: '12px', color: '#000', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer' },
    cancelBtn: { width: '100%', padding: '12px', marginTop: '8px', background: 'transparent', border: 'none', color: '#8b949e', fontSize: '13px', cursor: 'pointer' }
};

export default Shop;